import styled, {css} from 'styled-components';

import {Icon} from 'components/ui-kit/Icon';
import {border, colors} from 'theme';

import {IconButton} from '../../../IconButton';

export const FilterIconContainer = styled(Icon)<{active: boolean; fillColor?: string}>`
    padding: 3px;
    border-radius: ${border.radius};
    cursor: pointer;
    color: ${(p) => p.fillColor};
    transition: color 0.15s ease-in-out;
    ${({active}) =>
        active &&
        css`
            color: ${colors.brandPrimary};
        `};

    &:hover {
        color: ${colors.brandPrimary};
    }
`;

export const FilterContent = styled.div`
    position: relative;
    width: 330px;
    background: rgb(255, 255, 255);
    box-shadow: 0 1px 13px rgba(0, 0, 0, 0.1);
    padding: 12px 20px 20px 20px;
    box-sizing: border-box;
    z-index: 1;
    transition: all 1s linear;
    border-radius: ${border.radius};
`;

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    padding-top: 20px;
    gap: 10px;
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    width: auto;
    height: auto;
    top: 12px;
    right: 20px;

    padding: 0;

    &:hover {
        svg {
            fill: ${colors.textPrimary};
        }
    }
`;

export const HeaderWrapper = styled.div`
    margin-bottom: 10px;
`;
